import api from './api';

export const getMenuList = async () => {
  try {
    const response = await api.get('/api/Menu/GetMenuList');
    return response.data;
  } catch (error) {
    console.error('Error getting menu list:', error);
    throw error;
  }
};

export const updateMenu = async (menuData) => {
  try {
    // Sadece isPage ve dynamicPage true olan menüler düzenlenebilir
    if (!(menuData.isPage && menuData.dynamicPage)) {
      return { 
        isSuccess: false, 
        resultMessage: 'Bu menü düzenlenemez. Düzenlenebilmesi için hem "Sayfa Menüsü" hem de "Dinamik İçerikli Sayfa" olmalıdır.' 
      };
    }

    // API'ye gönderilecek payload
    const payload = {
      id: menuData.guid, // Menünün GUID'si
      code: menuData.code,
      name: menuData.name,
      isPage: menuData.isPage,
      dynamicPage: menuData.dynamicPage,
      parentMenuId: menuData.parentMenuId, // Üst menü seçimi
      displayOrder: menuData.displayOrder,
      html: menuData.html,
      hasPopupNotification: menuData.hasPopupNotification,
      popupContents: menuData.hasPopupNotification ? menuData.popupContents : '',
      popupStartDate: menuData.hasPopupNotification ? menuData.popupStartDate : null,
      popupEndDate: menuData.hasPopupNotification ? menuData.popupEndDate : null
    };

    console.log('Menü güncelleme verisi:', payload);
    const response = await api.post('/api/Menu/UpdateMenu', payload);
    console.log('API yanıtı:', response);
    
    // API yanıtını kontrol et
    if (response.data === true || response.data === 'true' || response.data?.isSuccess) {
      return { isSuccess: true, resultMessage: 'Menü başarıyla güncellendi.' };
    }
    
    return response.data;
  } catch (error) {
    console.error('Error updating menu:', error);
    return { isSuccess: false, resultMessage: error.message || 'Menü güncellenirken bir hata oluştu.' };
  }
};

export const deleteMenu = async (guid) => {
  try {
    const response = await api.post('/api/Menu/DeleteMenu', { guid });
    console.log('API yanıtı:', response);
    return response.data;
  } catch (error) {
    console.error('Error deleting menu:', error);
    throw error;
  }
};

// Sayfa HTML içeriğini getir
export const getPageHtml = async (pageId) => {
  try {
    const response = await api.get(`/api/Page/GetPage/${pageId}`);
    return response.data.html;
  } catch (error) {
    console.error('Error getting page HTML:', error);
    throw error;
  }
};

// Tüm sayfaları getir
export const getAllPages = async () => {
  try {
    const response = await api.get('/api/Page/GetPages');
    return response.data;
  } catch (error) {
    console.error('Error getting pages:', error);
    throw error;
  }
};

export const addMenu = async (menuData) => {
  try {
    // API'ye gönderilecek payload
    const payload = {
      code: menuData.code,
      name: menuData.name,
      isPage: menuData.isPage,
      dynamicPage: menuData.dynamicPage,
      parentMenuId: menuData.parentMenuId, // Üst menü seçimi
      displayOrder: menuData.displayOrder,
      html: menuData.isPage && menuData.dynamicPage ? menuData.html : '',
      hasPopupNotification: menuData.hasPopupNotification,
      popupContents: menuData.hasPopupNotification ? menuData.popupContents : '',
      popupStartDate: menuData.hasPopupNotification ? menuData.popupStartDate : null,
      popupEndDate: menuData.hasPopupNotification ? menuData.popupEndDate : null
    };

    console.log('Menü ekleme verisi:', payload);
    const response = await api.post('/api/Menu/AddMenu', payload);
    console.log('API yanıtı:', response);
    
    // API yanıtını kontrol et
    if (response.data === true || response.data === 'true' || response.data?.isSuccess) {
      return { isSuccess: true, resultMessage: 'Menü başarıyla eklendi.' };
    }
    
    return response.data;
  } catch (error) {
    console.error('Error adding menu:', error);
    return { isSuccess: false, resultMessage: error.message || 'Menü eklenirken bir hata oluştu.' };
  }
};
